<template>
  <div>
    <v-btn
      flat
      class="hidden-xs-only px-0"
      @click.native="logout"
      v-shortkey="['ctrl', 'l']"
      @shortkey.native="logout()"
    >
      <strong class="profile-text">{{ userName }}</strong
      >&nbsp;
      <v-icon color="red">flaticon-logout</v-icon>
    </v-btn>

    <v-menu
      min-width="250"
      offset-y
      transition="scale-transition"
      origin="right center"
      class="hidden-sm-and-up"
    >
      <v-btn
        id="loggedInEmployee"
        icon
        small
        flat
        color="info"
        slot="activator"
      >
        <v-icon color="primary">flaticon-avatar</v-icon>
      </v-btn>
      <v-list class="py-0">
        <v-list-tile
          @click.native="logout"
          class="cursor-pointer grey lighten-3"
          v-shortkey="['ctrl', 'l']"
          @shortkey.native="logout()"
        >
          <v-icon color="primary">flaticon-avatar</v-icon>&nbsp;
          <v-list-tile-title>{{ userName }}</v-list-tile-title>
          <v-icon color="red">flaticon-logout</v-icon>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile class="grey lighten-3">
          <v-list-tile-title class="text-xs-right px-2">{{
            node
          }}</v-list-tile-title>
          <v-icon>flaticon-pos-terminal</v-icon>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      userName: localStorage.getItem("userName"),
      node: localStorage.getItem("nodeId") || "",
    };
  },
  props: {
    showOperations: Boolean,
  },
  methods: {
    logout() {
      localStorage.removeItem("userId");
      localStorage.removeItem("userRoleId");
      localStorage.removeItem("userName");
      localStorage.removeItem("privileges");
      this.$router.push("/store/" + localStorage.getItem("storeId") + "/home");
    },
    gotoSettings() {
      this.$router.push(
        "/store/" +
          localStorage.getItem("storeId") +
          "/operations/posConfiguration"
      );
    },
    goTo(path) {
      this.$emit("navigate", path);
    },
  }
};
</script>

<style>
.profile-text {
  /* color: #fff !important; */
}
</style>
